var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M759.9 662.4c-12.6-9.4-31.5-9.4-40.9 3.1l-72.3 69.2c-9.4 9.4-25.2 12.6-37.7 6.3-69.2-37.7-132.1-84.9-185.6-138.4-53.5-53.4-100.7-116.3-138.4-185.5-6.3-12.6-3.1-28.3 6.3-37.7l72.3-72.3c12.6-12.6 12.6-28.3 3.1-40.9L266.1 143.4s0-3.1-3.1-3.1c-12.6-12.6-31.5-12.6-44 0l-85 84.9c-40.9 40.9 62.9 235.9 245.4 421.5S759.9 932.9 800.8 892l84.9-84.9 3.1-3.1c9.4-12.6 9.4-34.6-6.3-44l-122.6-97.6z m-84.9-44c34.6-34.6 88.1-37.7 125.8-6.3l122.7 97.5c40.9 31.5 47.2 91.2 15.7 132.1-3.1 3.1-3.1 6.3-6.3 6.3L848 932.9c-81.8 81.8-302-34.6-512.7-245.4S11.3 259.8 89.9 178l84.9-84.9c37.7-37.7 97.5-37.7 132.1 0l6.3 6.3L410.8 222c31.5 37.7 28.3 91.2-6.3 125.8L351 401.3c34.6 56.6 72.3 106.9 116.4 151s94.4 81.8 151 116.4l56.6-50.3zM564.9 193.7c-18.9 0-31.5-12.6-31.5-31.5s12.6-31.5 31.5-31.5c173 0 314.6 141.5 314.6 314.6 0 18.9-12.6 31.5-31.5 31.5s-31.5-12.6-31.5-31.5c0.1-138.3-113.2-251.6-251.6-251.6z m0 125.8c-18.9 0-31.5-12.6-31.5-31.5s12.6-31.5 31.5-31.5c103.8 0 188.7 84.9 188.7 188.7 0 18.9-12.6 31.5-31.5 31.5s-31.5-12.6-31.5-31.5c0.1-69-56.5-125.7-125.7-125.7z",
    fill: "#A594B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7e436279430cb8b8fae1610e221a8ca0.svg";
export { ForwardRef as ReactComponent };